import { configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import it from "@vee-validate/i18n/dist/locale/it.json";
import { defineRule } from "vee-validate";
import {
  required,
  email,
  min,
  max_value,
  min_value,
  max,
  numeric,
  length,
  between,
  regex,
  digits,
} from "@vee-validate/rules";
import { instance, prefix } from "@/api";
import { identity, isNil, stubTrue } from "lodash";
// import { prefix } from "@/api/helpers";
/* import { parse, parseISO } from "date-fns"; */

defineRule("required", required);
defineRule("email", email);
// For length
defineRule("min", min);
defineRule("max", max);
defineRule("length", length);

// For numbers
defineRule("max_value", max_value);
defineRule("min_value", min_value);
defineRule("numeric", numeric);
defineRule("between", between);
defineRule("digits", digits);
defineRule("regex", regex);

const customRules = {
  userUniqueEmail: async (
    email: string,
    {
      excluding,
      mapper = identity,
    }: { excluding?: string; mapper?: (email: string) => string } = {}
  ) => {
    return instance
      .post(`${prefix}/profile/validate`, {
        type: "userUniqueEmail",
        value: mapper(email),
        excluding,
      })
      .then(stubTrue)
      .catch(() => {
        return `Email già in uso`;
      });
  },
  // confirmed: (value:string, {target}:{target:any}, {field}:{field:string}) => {
  //   if(!overSome([isNil, isEmpty])(value)) {
  //     const x = value === target ? true : `Il campo ${field} non corrisponde`
  //     // return x;
  //   }
  //   return true;
  // },

  userUniquePhone: (
    phone: string,
    {
      excluding,
      mapper = identity,
    }: { excluding?: string; mapper?: (email: string) => string } = {}
  ) =>
    instance
      .post(`${prefix}/profile/validate`, {
        type: "userUniquePhone",
        value: mapper(phone),
        excluding,
      })
      .then(stubTrue)
      .catch(() => {
        return `Numero di telefono non valido`;
      }),
  phoneNumber: (string: string) => {
    const match = /^(\+39)?(((3[1-9][0-9]))(\d{7}|\d{6})|(0(04191|[1-9]{1,3})[0-9]{5,10}))$/.test(
      string
    );
    return match ? true : "Deve essere un numero di telefono valido senza prefisso internazionale.";
  },
  codiceFiscale: (string: string) => {
    const fiscalCodeRegex =
      /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
    const match = fiscalCodeRegex.test(string);
    return match ? true : "Il codice fiscale non è valido.";
  },
  // iban: (string: string) => {
  //   const ibanRegex =
  //     /^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/i;
  //   const match = ibanRegex.test(string);
  //   return match ? true : "IBAN non è valido.";
  // },
  decimal: (value: string | number) => {
    const decimalRegex = /^\d+(\.\d+)?$/;
    if (decimalRegex.test(value.toString())) {
      return true;
    }
    return `Il valore deve essere un numero`;
  },
};

Object.entries(customRules).forEach(([name, rule]) => {
  defineRule(name, rule);
});

defineRule("gte", (value: number, { target }: { target: number }) => {
  if (!isNil(value) && !isNil(target)) {
    if (+value < +target) return `Il valore deve essere maggiore o uguale a ${target}`;
  }
  return true;
});
defineRule("gte", (value: number, { target }: { target: number }) => {
  if (!isNil(value) && !isNil(target)) {
    if (+value <= +target) return `Il valore deve essere maggiore a ${target}`;
  }
  return true;
});
defineRule("gte", (value: number, { target }: { target: number }) => {
  if (!isNil(value) && !isNil(target)) {
    if (+value > +target) return `Il valore deve essere inferiore o uguale a ${target}`;
  }
  return true;
});
defineRule("gte", (value: number, { target }: { target: number }) => {
  if (!isNil(value) && !isNil(target)) {
    if (+value >= +target) return `Il valore deve essere inferiore a ${target}`;
  }
  return true;
});

configure({
  generateMessage: localize({
    it,
  }),
});

setLocale("it");
